module.exports = __webpack_public_path__ + "static/media/kaple-knihy.607c53b6.jpg";